import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NoWidgetDataComponent } from '../no-widget-data/no-widget-data.component';
import {LoaderComponent} from '../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-site-performance',
  imports: [NgFor, NgIf, NoWidgetDataComponent, LoaderComponent],
  templateUrl: './site-performance.component.html',
  styleUrl: './site-performance.component.scss'
})
export class SitePerformanceComponent {

  @Input() data: string[] = []
  @Input() loading: boolean = false;
  @Input() noDataView?: string;

  ngOnInit() {
  }
}
